export const assertHasValues = (values: Record<string, any>) => {
  if (import.meta.dev) {
    for (const key of Object.keys(values)) {
      if (values[key] === undefined) {
        throw new Error(`Missing ${key}`);
      }
    }
  }
};
